import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ChildrenDataTable {
  constructor() {
    $(document).ready(function() {
      showChildrenTable();
    });

    $(document).on("turbo:render", function() {
      showChildrenTable();
    });

    function showChildrenTable() {
      $('#children-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#person-children-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "first_name"},
          {"data": "last_name"},
          {"data": "birthdate"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
